import { describeReplyStatus } from 'src/app/chat/transcript';
import { IChatUiMessage } from 'src/hooks/useChat';

export const TOOL_LIMIT_NOTICE =
  "I reached my tool limit before finishing this reply. Select Continue and I'll pick up where I left off.";

/** The notice for a finished assistant reply with no text, chart or table; null when the chat already explains it elsewhere. */
export const emptyReplyNotice = (message: IChatUiMessage): string | null => {
  // The chat panel's error banner shows the server's message for a live failure.
  if (message.interruption === 'failed') return null;
  // The bubble's cut-short notice covers the length limit.
  if (message.stopReason === 'max_tokens') return null;
  if (message.stopReason === 'max_tool_iterations') return TOOL_LIMIT_NOTICE;
  return describeReplyStatus(message);
};
